import React from 'react';
// Style
import styles from '../CampaignEditComponents.module.scss';

type FormSectionProps = {
  title: string;
  /** One line saying what the fields below decide. Omit when it is obvious. */
  hint?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * A labelled group of fields inside a campaign edit form. The edit forms run to
 * forty-odd fields, so each group carries a heading that says what it controls
 * rather than leaving the fields to run together.
 */
const FormSection = ({
  title,
  hint,
  children,
}: FormSectionProps): JSX.Element => (
  <section className={styles.section}>
    <header className={styles.sectionHeader}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {hint && <p className={styles.sectionHint}>{hint}</p>}
    </header>
    {children}
  </section>
);

export default FormSection;
